"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultSubsections = {
    patientId: patientIdFunction,
    ongoingWorkflow: ongoingWorkflowFunction,
    submissionId: submissionIDFunction,
    created_at: createdAtFunction,
    updated_at: updatedAtFunction,
};
exports.default = DefaultSubsections;
function patientIdFunction(__db, submission) {
    const owner = 'length' in submission['owner'] ? submission['owner'][0] : submission['owner'];
    return Promise.resolve(owner.toString());
}
function submissionIDFunction(__db, submission) {
    return Promise.resolve(submission === null || submission === void 0 ? void 0 : submission['_id'].toString());
}
function ongoingWorkflowFunction(__db, submission) {
    var _a;
    if ('ongoingWorkflow' in submission) {
        return Promise.resolve((_a = submission === null || submission === void 0 ? void 0 : submission['ongoingWorkflow']) === null || _a === void 0 ? void 0 : _a.toString());
    }
    return Promise.resolve(undefined);
}
function createdAtFunction(__db, submission) {
    return Promise.resolve(submission['created_at']);
}
function updatedAtFunction(__db, submission) {
    return Promise.resolve(submission['updated_at']);
}
//# sourceMappingURL=defaultSubsections.js.map